import React, { useState, useEffect, useRef } from 'react'
import DashBoardTable from '../ProGridTable/DashBoardTable';
import { getApi } from '../../../../utils/services';
import { PROJECT_DOCUMENTATION_RISK_GAUGE_DATA } from '../../../../utils/services/apiPath';
import { errorToast } from '../../../../utils/toastHelper';

const ProjectDocumentationRisKTable = ({ selectedProjectsQuery }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetchedData = useRef(false);
  const columns = [
    { field: "project", headerName: "Project" },
    { field: "company", headerName: "Partner" },
    { field: "totalAndExpectedCPRCount", headerName: "# of CPRs/Expected Number of CPRs" },
    { field: "totalAndExpected671Count", headerName: "# of 671/Expected Number of 671" },
    { field: "totalAndExpectedDavisBaconFormsCount", headerName: "# of Davis Bacon Forms/Expected Number of Davis Bacon Forms" },
    { field: "totalAndExpectedJourneyWorkerCertCount", headerName: "# of Journey Worker Certifications/Expected Number of Journey Worker Certifications" },
  ];

  const fetchProjectRiskData = async () => {
    try {
      setLoading(true);
      const { data } = await getApi(`${PROJECT_DOCUMENTATION_RISK_GAUGE_DATA}?projectIds=${selectedProjectsQuery}`);

      const rowsWithId = data.map((item, index) => ({
        id: `row-${index}`,
        project: item.project,
        company: item.company,
        totalAndExpectedCPRCount: item.totalAndExpectedCPRCount,
        totalAndExpected671Count: item.totalAndExpected671Count,
        totalAndExpectedDavisBaconFormsCount: item.totalAndExpectedDavisBaconFormsCount,
        totalAndExpectedJourneyWorkerCertCount: item.totalAndExpectedJourneyWorkerCertCount,
      }));
      setRows(rowsWithId);
      setLoading(false);
    } catch (error) {
      errorToast(error)
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!hasFetchedData.current) {
      hasFetchedData.current = true;
      fetchProjectRiskData();
    }
  }, [selectedProjectsQuery]);

  return (
    <div style={{ marginTop: "20px" }}>
      <DashBoardTable
        columns={columns}
        rows={rows}
        getRowId={(row) => row.projectId}
        loading={loading}
        paginationModel={{ page: 0, pageSize: 5 }}
        hideExport={false}
        checkboxSelection={false}
      />
    </div>
  )
}

export default ProjectDocumentationRisKTable